import { FormControl, FormGroup } from '@angular/forms';
import { LoteInventarioModalItem } from '../../../shared/components/lote-inventario-modal/lote-inventario-modal.component';
import { SerieInventarioModalItem } from '../../../shared/components/serie-inventario-modal/serie-inventario-modal.component';
import { ControleEstoqueListStruct } from '../../../shared/services/structs/produto/controle-estoque-list.struct';

// Modelos locais da digitação de inventário, compartilhados entre a tela desktop
// (InventarioDigitacaoComponent) e a experiência mobile (InventarioDigitacaoMobileComponent).

export interface DigitacaoLocal {
  idLocalizacaoEstoque: number;
  nomeLocalizacao: string;
  saldoInicial: number;
  quantidadeInventariada: number | null;
  idInventarioItem?: number; // Quando carregado de inventário existente
  lotes?: LoteInventarioModalItem[];
  series?: SerieInventarioModalItem[];
  // Indica que o usuário abriu o modal de lote/série e confirmou a contagem.
  // Enquanto false, a contagem de lote/série é considerada zerada na conclusão.
  confirmadoRastreabilidade?: boolean;
}

export interface DigitacaoProduto {
  idProduto: number;
  nome: string;
  sku?: string;
  unidade: string;
  custoMedio: number;
  isControlaLotes: boolean;
  isControlaSeries: boolean;
  locais: DigitacaoLocal[];
  // Seleção de produto inline na própria linha (preenchido na tela desktop)
  produtoControl?: FormControl;
  produtoPreload?: any[];
}

export interface LinhaGrid {
  tipo: 'parent' | 'sub';
  idProduto: number;
  produto: DigitacaoProduto;
  local?: DigitacaoLocal;
}

export const ID_TIPO_ORIGEM_DIGITACAO_MANUAL = 1;
export const ID_TIPO_VALOR_BASE_PADRAO = 1;

// Superfície pública do componente desktop consumida pela experiência mobile.
// O desktop continua sendo a fonte única de estado; o mobile apenas lê e dispara ações.
// (Tipagem estrutural evita dependência circular entre os dois componentes.)
export interface InventarioDigitacaoHost {
  formInventario: FormGroup;
  listaLocalizacoes: any[];
  listaUsuarios: any[];
  itens: DigitacaoProduto[];
  isReadOnly: boolean;
  idInventario: number;
  idStatusInventario: number;
  mensagemProcessamento?: string;
  isEdicao: boolean;
  _isLoading: boolean;
  isSalvandoRascunho: boolean;
  isConcluindo: boolean;

  adicionarProduto(): Promise<void>;
  incluirProdutoDaBusca(p: ControleEstoqueListStruct): boolean;
  encontrarProduto(idProduto: number): DigitacaoProduto | undefined;
  removerProduto(idProduto: number): void;
  registrarContagem(idProduto: number, idLocalizacaoEstoque: number, quantidade: number | null): void;
  aplicarLotesNoLocal(idProduto: number, idLocalizacaoEstoque: number, lotes: LoteInventarioModalItem[]): void;
  aplicarSeriesNoLocal(idProduto: number, idLocalizacaoEstoque: number, series: SerieInventarioModalItem[]): void;
  rebuildGrid(): void;
  validarCabecalhoObrigatorio(): boolean;
  sugerirSalvarRascunhoNovoSeNecessario(): Promise<boolean>;
  salvarRascunhoAutomatico(): Promise<boolean>;
  salvarRascunho(): Promise<void>;
  concluirInventario(): Promise<void>;
  cancelar(): void;
}
